<template>
  <div>
    <v-overlay :value="state" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>

      <v-row justify="center" class="mt-10">
        <h3 class="ml-2">{{ message }}</h3>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "LoadingInfo",
  props: {
    state: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    }
  }
};
</script>

<style></style>
